var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedWidget.type === "input"
    ? _c(
        "el-form-item",
        { attrs: { label: _vm.i18nt("designer.setting.displayType") } },
        [
          _c(
            "el-select",
            {
              on: { change: _vm.changeType },
              model: {
                value: _vm.optionModel.type,
                callback: function ($$v) {
                  _vm.$set(_vm.optionModel, "type", $$v)
                },
                expression: "optionModel.type",
              },
            },
            [
              _c("el-option", { attrs: { label: "text", value: "text" } }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { label: "password", value: "password" },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }